import comp from "./Beacon";
export default comp;
